<template>
  <div>
  <div class="content">

    <b-container fluid class="mt-4">

      <stats-card title="Reports" type="default" sub-title="All reports" icon="fas fa-clipboard-list">

        <template slot="actions">
            <a class="dropdown-item" @click="showAddReport = true">Create new</a>
        </template>

        <template slot="append">

          <div class="mt-4">
            <entity-picker v-if="rolesData.length > 0"
                :canEdit="true"
                :canSelect="false"
                placeHolder="Start typing something..."
                apiEndpoint="getReports"
                :selected="rolesData"
                :cursorData="cursorData"
                editPath="/reports/"
                :tableColumns= tableColumns
                :filters="userFilters"
                rootProp="reports"
                :tableOptions="tableOptions"
            >
            </entity-picker>
          </div>

        </template>
      </stats-card>
    </b-container>
  </div>

  <modal :show.sync="showAddReport">
    <h6 slot="header" class="modal-title">Create new report</h6>

    <base-input label="Name:" v-model="newReport.name"></base-input>

    <div class="form-group">
        <label class="form-control-label">Frequency:</label>
        <b-form-select v-model="newReport.schedule" :options="reportFrequencies"></b-form-select>
    </div>

    <div class="form-group">
        <label class="form-control-label">Time of day:</label>

        <el-select class="select-primary pagination-select" v-model="newReport.timeOfDay" placeholder="Pick an hour">
            <el-option
            class="select-primary"
            v-for="(item,index) in newReport.possibleHours"
            :key="index"
            :label="item"
            :value="parseInt(index)"
            >
            </el-option>
        </el-select>
    </div>

    <div class="form-group" v-if="newReport.isWeekly">
        <label class="form-control-label">Day of week:</label>
        <el-select class="select-primary pagination-select" v-model="newReport.dayOfWeek" placeholder="Pick a day">
            <el-option
            class="select-primary"
            v-for="(item,index) in newReport.possibleDays"
            :key="index"
            :label="item"
            :value="parseInt(index)"
            >
            </el-option>
        </el-select>
    </div>

    <div class="form-group" v-if="newReport.isMonthly">
        <label class="form-control-label">Day of the month:</label>
        <el-select class="select-primary pagination-select" v-model="newReport.dayOfWeek" placeholder="Pick a day">
            <el-option
            class="select-primary"
            v-for="(item,index) in 28"
            :key="index"
            :label="item"
            :value="parseInt(item)"
            >
            </el-option>
        </el-select>
    </div>

    <div class="form-group">
        <label class="form-control-label">Delivery Type:</label>
        <el-select class="select-primary pagination-select" v-model="newReport.deliveryType" placeholder="Pick a delivery method">
            <el-option
            class="select-primary"
            v-for="(item,index) in newReport.possibleDeliveryTypes"
            :key="index"
            :label="item"
            :value="parseInt(index)"
            >
            </el-option>
        </el-select>
    </div>

    <b-card no-bod class="tab-wrapper" v-if="newReport.doesValidate()">

        <b-card-header header-tag="nav">
            <b-nav card-header tabs>
                <b-nav-item @click="setActiveCreateTab(1)"  :active="activeCreateTab == 1">Orchards</b-nav-item>
                <b-nav-item @click="setActiveCreateTab(2)" :active="activeCreateTab == 2">Recipients</b-nav-item>
            </b-nav>
        </b-card-header>

        <div class="tab-container" v-if="activeCreateTab == 1">

            <entity-picker
                :key="`newReportOrchardPicker`"
                @onSelect="handleNewReportOrchard"
                :selected="newReportOrchards"
                placeHolder="Search for orchards to add"
                apiEndpoint="getGroups"
                rootProp="orchards"
                :multiple="true"
                :canBeEmpty="false"
            >
            </entity-picker>

        </div>

        <div class="tab-container" v-if="activeCreateTab == 2">

            <entity-picker
                :key="`newReportRecipientPicker`"
                @onSelect="handleNewReportRecipient"
                :selected="newReportRecipients"
                placeHolder="Search for users to add"
                apiEndpoint="getUsers"
                rootProp="users"
                :multiple="true"
                :canBeEmpty="false"
            >
            </entity-picker>

        </div>
    </b-card>


    <template slot="footer">
        <base-button type="blank" @click="showAddReport= false">Cancel</base-button>
        <base-button :disabled="newReportRecipients.length == 0 || newReportOrchards.length == 0" type="primary" @click="createReport">Create report</base-button>
    </template>
</modal>


  </div>
</template>


<script>
import api from '@/api'
import { Select, Option } from 'element-ui'
import { tableColumns, tableFilters, tableOptions } from '@/config/ReportTable'
import BaseAlert from '../components/BaseAlert.vue';
import { ReportModel } from '@/models/report/report'

export default {
  components: {
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      reportTypes: [
          'flyrt',
          'detections'
      ],
      reportFrequencies: [
          'daily',
          'weekly',
          'monthly'
      ],
      showAddReport: false,
      newReport: new ReportModel,
      newReportOrchards: [],
      newReportRecipients: [],
      tableColumns: tableColumns,
      userFilters: tableFilters,
      tableOptions: tableOptions,
      createActivate: true,
      createDefault: false,
      rolesData: [],
      activeCreateTab: 1,
      cursorData: null,
      selectedRows: [],
      currentUser: null
    };
  },
  created: async function() {
    this.$emit('loading', true);
    const results = await api.getReports()
    // {
    //   sort: this.tableOptions['default-sort'].prop,
    //   direction: this.tableOptions['default-sort'].order == 'ascending' ? 'asc' : 'desc',
    //   limit: this.tableOptions.limit
    // }
    this.$emit('loading', false);
    this.rolesData = results.reports;
    this.cursorData = results.cursor
    this.getCurrentUser()
  },
  methods: {
    getCurrentUser() {
      this.currentUser = JSON.parse(localStorage.getItem('profile'))
    },
    setActiveCreateTab(tab) {
        this.activeCreateTab = tab
    },
    handleNewReportOrchard(orchards) {
      this.newReportOrchards = orchards
    },
    handleNewReportRecipient(recipients) {
      this.newReportRecipients = recipients
    },
    createReport: async function() {
      let payload = {
        ... this.newReport.exportToCreate(),
        orchards: this.newReportOrchards.map((o) => {
          return {groupId: o.id}
        }),
        recipients: this.newReportRecipients.map((r) => {
          return {userId: r.id}
        }),
        authorId: this.currentUser.id || (this.currentUser.profile && this.currentUser.profile.pgId)
      }

      this.showAddReport = false
      this.$emit('loading', true);
      const createdReport = await api.createReport(payload);
      this.$emit('loading', false);
      this.$emit('onApiResult', 'Report created, redirecting you to it...');
      this.$router.push(`/reports/${createdReport.id}?created`);
      // console.log(payload)
    }
  }
};
</script>
